import { DEFAULT_PROGRAM } from './defaultProgram';

export const PRESET_SPLITS = [
  {
    id: "koah",
    name: "PPL / Upper-Lower",
    tag: "Koah's Split",
    description: "A hybrid split combining Push/Pull/Legs and Upper/Lower. 5 days a week, excellent balance of volume and recovery. Works for beginners through advanced.",
    daysPerWeek: 5,
    color: "#4f8fff",
    isDefault: true,
    dayStructure: [
      { name: "Rest",  color: null,      isRest: true  },
      { name: "Upper", color: "#3b82f6", isRest: false },
      { name: "Lower", color: "#8b5cf6", isRest: false },
      { name: "Rest",  color: null,      isRest: true  },
      { name: "Push",  color: "#f59e0b", isRest: false },
      { name: "Pull",  color: "#10b981", isRest: false },
      { name: "Legs",  color: "#ef4444", isRest: false },
    ],
    exercises: {
      1: DEFAULT_PROGRAM[1].exercises.map(e => ({ ...e })),
      2: DEFAULT_PROGRAM[2].exercises.map(e => ({ ...e })),
      4: DEFAULT_PROGRAM[4].exercises.map(e => ({ ...e })),
      5: DEFAULT_PROGRAM[5].exercises.map(e => ({ ...e })),
      6: DEFAULT_PROGRAM[6].exercises.map(e => ({ ...e })),
    },
  },
  {
    id: "ppl3",
    name: "Push / Pull / Legs",
    tag: "PPL — 3 Day",
    description: "One Push, Pull, and Legs session per week. Good entry point into PPL — lower volume, plenty of recovery. Works well for beginners or anyone juggling a busy schedule.",
    daysPerWeek: 3,
    color: "#f59e0b",
    dayStructure: [
      { name: "Rest",  color: null,      isRest: true  },
      { name: "Push",  color: "#f59e0b", isRest: false },
      { name: "Rest",  color: null,      isRest: true  },
      { name: "Pull",  color: "#10b981", isRest: false },
      { name: "Rest",  color: null,      isRest: true  },
      { name: "Legs",  color: "#ef4444", isRest: false },
      { name: "Rest",  color: null,      isRest: true  },
    ],
    exercises: {
      1: [
        { id: "bench-press",     name: "Bench Press",     sets: 4, rLo: 6, rHi: 8,  compound: true,  inc: 5   },
        { id: "incline-db-press",name: "Incline DB Press",sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "ohp",             name: "OHP",             sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "lateral-raise",   name: "Lateral Raise",   sets: 3, rLo: 15,rHi: 20, compound: false, inc: 2.5 },
        { id: "cable-pushdown",  name: "Cable Pushdown",  sets: 3, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
        { id: "skullcrushers",   name: "Skullcrushers",   sets: 3, rLo: 10,rHi: 12, compound: false, inc: 2.5 },
      ],
      3: [
        { id: "deadlift",      name: "Deadlift",      sets: 3, rLo: 5, rHi: 5,  compound: true,  inc: 5   },
        { id: "barbell-row",   name: "Barbell Row",   sets: 3, rLo: 6, rHi: 8,  compound: true,  inc: 5   },
        { id: "lat-pulldown",  name: "Lat Pulldown",  sets: 3, rLo: 10,rHi: 12, compound: true,  inc: 5   },
        { id: "face-pull",     name: "Face Pull",     sets: 3, rLo: 15,rHi: 20, compound: false, inc: 2.5 },
        { id: "barbell-curl",  name: "Barbell Curl",  sets: 3, rLo: 10,rHi: 12, compound: false, inc: 2.5 },
        { id: "hammer-curl",   name: "Hammer Curl",   sets: 3, rLo: 10,rHi: 12, compound: false, inc: 2.5 },
      ],
      5: [
        { id: "back-squat",          name: "Back Squat",          sets: 4, rLo: 5, rHi: 8,  compound: true,  inc: 5   },
        { id: "rdl",                 name: "Romanian Deadlift",   sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "leg-press",           name: "Leg Press",           sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "leg-curl",            name: "Lying Leg Curl",      group: "Hamstrings & Glutes", sets: 3, rLo: 12, rHi: 15, compound: false, inc: 2.5, videoId: "1Tq3QdYUuHs", muscles: { primary: ["hamstrings"], secondary: [] } },
        { id: "leg-extension",       name: "Leg Extension",       sets: 3, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
        { id: "standing-calf-raise", name: "Standing Calf Raise", sets: 4, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
      ],
    },
  },
  {
    id: "ppl6",
    name: "Push / Pull / Legs",
    tag: "PPL — 6 Day",
    description: "The full PPL cycle run twice a week. 6 days on, 1 rest. High frequency and high volume — each muscle group hits twice weekly. Best for intermediate to advanced lifters.",
    daysPerWeek: 6,
    color: "#f59e0b",
    dayStructure: [
      { name: "Rest",  color: null,      isRest: true  },
      { name: "Push",  color: "#f59e0b", isRest: false },
      { name: "Pull",  color: "#10b981", isRest: false },
      { name: "Legs",  color: "#ef4444", isRest: false },
      { name: "Push",  color: "#f59e0b", isRest: false },
      { name: "Pull",  color: "#10b981", isRest: false },
      { name: "Legs",  color: "#ef4444", isRest: false },
    ],
    exercises: {
      1: [
        { id: "bench-press",     name: "Bench Press",     sets: 4, rLo: 6, rHi: 8,  compound: true,  inc: 5   },
        { id: "incline-db-press",name: "Incline DB Press",sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "ohp",             name: "OHP",             sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "lateral-raise",   name: "Lateral Raise",   sets: 3, rLo: 15,rHi: 20, compound: false, inc: 2.5 },
        { id: "cable-pushdown",  name: "Cable Pushdown",  sets: 3, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
        { id: "skullcrushers",   name: "Skullcrushers",   sets: 3, rLo: 10,rHi: 12, compound: false, inc: 2.5 },
      ],
      2: [
        { id: "deadlift",      name: "Deadlift",      sets: 3, rLo: 5, rHi: 5,  compound: true,  inc: 5   },
        { id: "barbell-row",   name: "Barbell Row",   sets: 3, rLo: 6, rHi: 8,  compound: true,  inc: 5   },
        { id: "lat-pulldown",  name: "Lat Pulldown",  sets: 3, rLo: 10,rHi: 12, compound: true,  inc: 5   },
        { id: "face-pull",     name: "Face Pull",     sets: 3, rLo: 15,rHi: 20, compound: false, inc: 2.5 },
        { id: "barbell-curl",  name: "Barbell Curl",  sets: 3, rLo: 10,rHi: 12, compound: false, inc: 2.5 },
        { id: "hammer-curl",   name: "Hammer Curl",   sets: 3, rLo: 10,rHi: 12, compound: false, inc: 2.5 },
      ],
      3: [
        { id: "back-squat",          name: "Back Squat",          sets: 4, rLo: 5, rHi: 8,  compound: true,  inc: 5   },
        { id: "rdl",                 name: "Romanian Deadlift",   sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "leg-press",           name: "Leg Press",           sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "leg-curl",            name: "Lying Leg Curl",      sets: 3, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
        { id: "leg-extension",       name: "Leg Extension",       sets: 3, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
        { id: "standing-calf-raise", name: "Standing Calf Raise", sets: 4, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
      ],
      4: [
        { id: "incline-db-press",name: "Incline DB Press",sets: 4, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "cable-fly",       name: "Cable Fly",       sets: 3, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
        { id: "seated-db-press", name: "Seated DB Press", sets: 3, rLo: 10,rHi: 12, compound: true,  inc: 5   },
        { id: "lateral-raise",   name: "Lateral Raise",   sets: 4, rLo: 15,rHi: 20, compound: false, inc: 2.5 },
        { id: "cable-pushdown",  name: "Cable Pushdown",  sets: 3, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
        { id: "skullcrushers",   name: "Skullcrushers",   sets: 3, rLo: 10,rHi: 12, compound: false, inc: 2.5 },
      ],
      5: [
        { id: "chest-supported-row",name: "Chest-Supported Row",sets: 4, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "pull-ups",           name: "Pull-ups",           sets: 3, rLo: 6, rHi: 10, compound: true,  inc: 5   },
        { id: "lat-pulldown",       name: "Lat Pulldown",       sets: 3, rLo: 10,rHi: 12, compound: true,  inc: 5   },
        { id: "face-pull",          name: "Face Pull",          sets: 3, rLo: 15,rHi: 20, compound: false, inc: 2.5 },
        { id: "barbell-curl",       name: "Barbell Curl",       sets: 3, rLo: 10,rHi: 12, compound: false, inc: 2.5 },
        { id: "hammer-curl",        name: "Hammer Curl",        sets: 3, rLo: 10,rHi: 12, compound: false, inc: 2.5 },
      ],
      6: [
        { id: "hack-squat",          name: "Hack Squat",          sets: 4, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "bulgarian-split-squat",name:"Bulgarian Split Squat",sets:3, rLo: 10,rHi: 12, compound: true,  inc: 5   },
        { id: "rdl",                 name: "Romanian Deadlift",   sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "leg-curl",            name: "Lying Leg Curl",      sets: 3, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
        { id: "standing-calf-raise", name: "Standing Calf Raise", sets: 4, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
        { id: "cable-crunch",        name: "Cable Crunch",        sets: 3, rLo: 15,rHi: 20, compound: false, inc: 2.5 },
      ],
    },
  },
  {
    id: "ul",
    name: "Upper / Lower",
    tag: "4-Day Split",
    description: "Training each muscle group twice a week for maximum growth stimulus. 4 days, great balance of frequency and recovery. Perfect for intermediate lifters.",
    daysPerWeek: 4,
    color: "#3b82f6",
    dayStructure: [
      { name: "Rest",    color: null,      isRest: true  },
      { name: "Upper A", color: "#3b82f6", isRest: false },
      { name: "Lower A", color: "#8b5cf6", isRest: false },
      { name: "Rest",    color: null,      isRest: true  },
      { name: "Upper B", color: "#3b82f6", isRest: false },
      { name: "Lower B", color: "#8b5cf6", isRest: false },
      { name: "Rest",    color: null,      isRest: true  },
    ],
    exercises: {
      1: [
        { id: "bench-press",    name: "Bench Press",       sets: 3, rLo: 5, rHi: 8,  compound: true,  inc: 5   },
        { id: "barbell-row",    name: "Barbell Row",       sets: 3, rLo: 6, rHi: 8,  compound: true,  inc: 5   },
        { id: "ohp",            name: "OHP",               sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "lat-pulldown",   name: "Lat Pulldown",      sets: 3, rLo: 10,rHi: 12, compound: true,  inc: 5   },
        { id: "lateral-raise",  name: "Lateral Raise",     sets: 3, rLo: 15,rHi: 20, compound: false, inc: 2.5 },
        { id: "barbell-curl",   name: "Barbell Curl",      sets: 3, rLo: 10,rHi: 12, compound: false, inc: 2.5 },
      ],
      2: [
        { id: "back-squat",          name: "Back Squat",          sets: 3, rLo: 5, rHi: 8,  compound: true,  inc: 5   },
        { id: "rdl",                 name: "Romanian Deadlift",   sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "leg-press",           name: "Leg Press",           sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "leg-curl",            name: "Lying Leg Curl",      sets: 3, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
        { id: "standing-calf-raise", name: "Standing Calf Raise", sets: 4, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
      ],
      4: [
        { id: "incline-db-press",   name: "Incline DB Press",     sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "chest-supported-row",name: "Chest-Supported Row",  sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "seated-db-press",    name: "Seated DB Press",      sets: 3, rLo: 10,rHi: 12, compound: true,  inc: 5   },
        { id: "pull-ups",           name: "Pull-ups",             sets: 3, rLo: 6, rHi: 10, compound: true,  inc: 5   },
        { id: "cable-pushdown",     name: "Cable Pushdown",       sets: 3, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
        { id: "hammer-curl",        name: "Hammer Curl",          sets: 3, rLo: 10,rHi: 12, compound: false, inc: 2.5 },
      ],
      5: [
        { id: "deadlift",            name: "Deadlift",            sets: 3, rLo: 5, rHi: 5,  compound: true,  inc: 5   },
        { id: "bulgarian-split-squat",name:"Bulgarian Split Squat",sets:3, rLo: 10,rHi: 12, compound: true,  inc: 5   },
        { id: "leg-extension",       name: "Leg Extension",       sets: 3, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
        { id: "leg-curl",            name: "Lying Leg Curl",      sets: 3, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
        { id: "standing-calf-raise", name: "Standing Calf Raise", sets: 4, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
      ],
    },
  },
  {
    id: "fullbody",
    name: "Full Body 3×",
    tag: "3-Day Split",
    description: "Hit every muscle group 3 times a week. Great for beginners building a foundation, or busy lifters who can only train 3 days. Maximum frequency.",
    daysPerWeek: 3,
    color: "#10b981",
    dayStructure: [
      { name: "Rest",      color: null,      isRest: true  },
      { name: "Full Body", color: "#10b981", isRest: false },
      { name: "Rest",      color: null,      isRest: true  },
      { name: "Full Body", color: "#10b981", isRest: false },
      { name: "Rest",      color: null,      isRest: true  },
      { name: "Full Body", color: "#10b981", isRest: false },
      { name: "Rest",      color: null,      isRest: true  },
    ],
    exercises: {
      1: [
        { id: "back-squat",   name: "Back Squat",     sets: 3, rLo: 5, rHi: 8,  compound: true,  inc: 5   },
        { id: "bench-press",  name: "Bench Press",    sets: 3, rLo: 5, rHi: 8,  compound: true,  inc: 5   },
        { id: "barbell-row",  name: "Barbell Row",    sets: 3, rLo: 6, rHi: 8,  compound: true,  inc: 5   },
        { id: "ohp",          name: "OHP",            sets: 2, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "lat-pulldown", name: "Lat Pulldown",   sets: 2, rLo: 10,rHi: 12, compound: true,  inc: 5   },
        { id: "lateral-raise",name: "Lateral Raise",  sets: 2, rLo: 15,rHi: 20, compound: false, inc: 2.5 },
      ],
      3: [
        { id: "deadlift",       name: "Deadlift",       sets: 3, rLo: 5, rHi: 5,  compound: true,  inc: 5   },
        { id: "incline-db-press",name:"Incline DB Press",sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "pull-ups",       name: "Pull-ups",       sets: 3, rLo: 6, rHi: 10, compound: true,  inc: 5   },
        { id: "seated-db-press",name: "Seated DB Press",sets: 2, rLo: 10,rHi: 12, compound: true,  inc: 5   },
        { id: "barbell-curl",   name: "Barbell Curl",   sets: 2, rLo: 10,rHi: 12, compound: false, inc: 2.5 },
        { id: "cable-pushdown", name: "Cable Pushdown", sets: 2, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
      ],
      5: [
        { id: "back-squat",     name: "Back Squat",     sets: 3, rLo: 5, rHi: 8,  compound: true,  inc: 5   },
        { id: "bench-press",    name: "Bench Press",    sets: 3, rLo: 5, rHi: 8,  compound: true,  inc: 5   },
        { id: "barbell-row",    name: "Barbell Row",    sets: 3, rLo: 6, rHi: 8,  compound: true,  inc: 5   },
        { id: "rdl",            name: "Romanian Deadlift",sets:2,rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "lateral-raise",  name: "Lateral Raise",  sets: 2, rLo: 15,rHi: 20, compound: false, inc: 2.5 },
        { id: "hammer-curl",    name: "Hammer Curl",    sets: 2, rLo: 10,rHi: 12, compound: false, inc: 2.5 },
      ],
    },
  },
  {
    id: "bro",
    name: "Bro Split",
    tag: "5-Day Split",
    description: "One muscle group per day, 5 days a week. Maximum volume per muscle, classic bodybuilding approach. Best for intermediate to advanced lifters.",
    daysPerWeek: 5,
    color: "#ef4444",
    dayStructure: [
      { name: "Rest",      color: null,      isRest: true  },
      { name: "Chest",     color: "#ef4444", isRest: false },
      { name: "Back",      color: "#10b981", isRest: false },
      { name: "Shoulders", color: "#f59e0b", isRest: false },
      { name: "Arms",      color: "#a78bfa", isRest: false },
      { name: "Legs",      color: "#8b5cf6", isRest: false },
      { name: "Rest",      color: null,      isRest: true  },
    ],
    exercises: {
      1: [
        { id: "bench-press",     name: "Bench Press",     sets: 4, rLo: 6, rHi: 8,  compound: true,  inc: 5   },
        { id: "incline-db-press",name: "Incline DB Press",sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "cable-fly",       name: "Cable Fly",       sets: 3, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
        { id: "chest-dip",       name: "Chest Dips",      sets: 3, rLo: 8, rHi: 12, compound: true,  inc: 5   },
      ],
      2: [
        { id: "deadlift",           name: "Deadlift",           sets: 3, rLo: 5, rHi: 5,  compound: true,  inc: 5   },
        { id: "barbell-row",        name: "Barbell Row",        sets: 3, rLo: 6, rHi: 8,  compound: true,  inc: 5   },
        { id: "lat-pulldown",       name: "Lat Pulldown",       sets: 3, rLo: 10,rHi: 12, compound: true,  inc: 5   },
        { id: "chest-supported-row",name: "Chest-Supported Row",sets: 3, rLo: 10,rHi: 12, compound: true,  inc: 5   },
        { id: "face-pull",          name: "Face Pull",          sets: 3, rLo: 15,rHi: 20, compound: false, inc: 2.5 },
      ],
      3: [
        { id: "ohp",          name: "OHP",          sets: 4, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "seated-db-press",name:"Seated DB Press",sets:3,rLo: 10,rHi: 12, compound: true,  inc: 5   },
        { id: "lateral-raise",name: "Lateral Raise",sets: 4, rLo: 15,rHi: 20, compound: false, inc: 2.5 },
        { id: "face-pull",    name: "Face Pull",    sets: 3, rLo: 15,rHi: 20, compound: false, inc: 2.5 },
      ],
      4: [
        { id: "barbell-curl",  name: "Barbell Curl",  sets: 4, rLo: 10,rHi: 12, compound: false, inc: 2.5 },
        { id: "hammer-curl",   name: "Hammer Curl",   sets: 3, rLo: 10,rHi: 12, compound: false, inc: 2.5 },
        { id: "skullcrushers", name: "Skullcrushers", sets: 4, rLo: 10,rHi: 12, compound: false, inc: 2.5 },
        { id: "cable-pushdown",name: "Cable Pushdown",sets: 3, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
      ],
      5: [
        { id: "back-squat",          name: "Back Squat",          sets: 4, rLo: 5, rHi: 8,  compound: true,  inc: 5   },
        { id: "leg-press",           name: "Leg Press",           sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "rdl",                 name: "Romanian Deadlift",   sets: 3, rLo: 8, rHi: 10, compound: true,  inc: 5   },
        { id: "leg-curl",            name: "Lying Leg Curl",      sets: 3, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
        { id: "leg-extension",       name: "Leg Extension",       sets: 3, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
        { id: "standing-calf-raise", name: "Standing Calf Raise", sets: 4, rLo: 12,rHi: 15, compound: false, inc: 2.5 },
      ],
    },
  },
  {
    id: "lowerfocus",
    name: "Lower Body Focus",
    tag: "Glute & Leg Bias",
    description: "Three lower body sessions and one upper per week. Glute and hamstring dominant with quad work built in. Great for anyone prioritizing leg development and lower body strength.",
    daysPerWeek: 4,
    color: "#ec4899",
    dayStructure: [
      { name: "Rest",    color: null,      isRest: true  },
      { name: "Lower A", color: "#ec4899", isRest: false },
      { name: "Upper",   color: "#8b5cf6", isRest: false },
      { name: "Rest",    color: null,      isRest: true  },
      { name: "Lower B", color: "#f472b6", isRest: false },
      { name: "Lower C", color: "#ec4899", isRest: false },
      { name: "Rest",    color: null,      isRest: true  },
    ],
    exercises: {
      1: [
        { id: "hip-thrust",           name: "Hip Thrust",           sets: 4, rLo: 8,  rHi: 12, compound: true,  inc: 5   },
        { id: "rdl",                  name: "Romanian Deadlift",    sets: 4, rLo: 8,  rHi: 10, compound: true,  inc: 5   },
        { id: "bulgarian-split-squat",name: "Bulgarian Split Squat",sets: 3, rLo: 10, rHi: 12, compound: true,  inc: 5,  perLeg: true },
        { id: "cable-kickback",       name: "Cable Kickback",       sets: 3, rLo: 12, rHi: 15, compound: false, inc: 2.5, perLeg: true },
        { id: "leg-curl",             name: "Lying Leg Curl",       sets: 3, rLo: 12, rHi: 15, compound: false, inc: 2.5 },
        { id: "abductor",             name: "Hip Abductor Machine", sets: 3, rLo: 15, rHi: 20, compound: false, inc: 2.5 },
      ],
      2: [
        { id: "bench-press",     name: "Bench Press",     sets: 3, rLo: 8,  rHi: 10, compound: true,  inc: 5   },
        { id: "barbell-row",     name: "Barbell Row",     sets: 3, rLo: 8,  rHi: 10, compound: true,  inc: 5   },
        { id: "lat-pulldown",    name: "Lat Pulldown",    sets: 3, rLo: 10, rHi: 12, compound: true,  inc: 5   },
        { id: "ohp",             name: "OHP",             sets: 3, rLo: 10, rHi: 12, compound: true,  inc: 5   },
        { id: "lateral-raise",   name: "Lateral Raise",   sets: 3, rLo: 15, rHi: 20, compound: false, inc: 2.5 },
        { id: "face-pull",       name: "Face Pull",       sets: 3, rLo: 15, rHi: 20, compound: false, inc: 2.5 },
      ],
      4: [
        { id: "back-squat",          name: "Back Squat",          sets: 4, rLo: 6,  rHi: 8,  compound: true,  inc: 5   },
        { id: "leg-press",           name: "Leg Press",           sets: 3, rLo: 8,  rHi: 10, compound: true,  inc: 5   },
        { id: "walking-lunge",       name: "Walking Lunge",       sets: 3, rLo: 10, rHi: 12, compound: true,  inc: 5,  perLeg: true },
        { id: "leg-extension",       name: "Leg Extension",       sets: 3, rLo: 12, rHi: 15, compound: false, inc: 2.5 },
        { id: "standing-calf-raise", name: "Standing Calf Raise", sets: 4, rLo: 12, rHi: 15, compound: false, inc: 2.5 },
      ],
      5: [
        { id: "hip-thrust",     name: "Hip Thrust",           sets: 4, rLo: 10, rHi: 15, compound: true,  inc: 5   },
        { id: "sumo-deadlift",  name: "Sumo Deadlift",        sets: 3, rLo: 6,  rHi: 8,  compound: true,  inc: 5   },
        { id: "step-ups",       name: "Step-ups",             sets: 3, rLo: 12, rHi: 15, compound: true,  inc: 5,  perLeg: true },
        { id: "cable-kickback", name: "Cable Kickback",       sets: 3, rLo: 12, rHi: 15, compound: false, inc: 2.5, perLeg: true },
        { id: "abductor",       name: "Hip Abductor Machine", sets: 3, rLo: 15, rHi: 20, compound: false, inc: 2.5 },
        { id: "leg-curl",       name: "Lying Leg Curl",       sets: 3, rLo: 12, rHi: 15, compound: false, inc: 2.5 },
      ],
    },
  },
];
